export const incidentHeaders = [
  {
    "id": "id",
    "disablePadding": true,
    "label": "ID",
    "isFilterable": false,
    "showColumnUnExpanded": false
  },
  {
    "id": "findingName",
    "disablePadding": false,
    "label": "Name",
    "isFilterable": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "resourceids",
    "disablePadding": false,
    "label": "Resource IDs",
    "isFilterable": false,
    "showColumnUnExpanded": false
  },
  {
    "id": "severity",
    "disablePadding": false,
    "label": "Severity",
    "isFilterable": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "classification",
    "disablePadding": false,
    "label": "Classification",
    "isFilterable": true,
    "showColumnUnExpanded": false
  },
  {
    "id": "org",
    "disablePadding": false,
    "label": "Org",
    "isFilterable": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "assignedto",
    "disablePadding": false,
    "label": "Assigned to",
    "isFilterable": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "status",
    "disablePadding": false,
    "label": "Status",
    "isFilterable": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "createdDate",
    "disablePadding": false,
    "label": "Created Date",
    "isFilterable": true,
    "isDate": true,
    "showColumnUnExpanded": true
  },
  
     {
    "id": "falsePositiveProbability",
    "disablePadding": false,
    "label": "False Positive Probability",
    "isFilterable": true,
    "isDate": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "riskScore",
    "disablePadding": false,
    "label": "Risk Score",
    "isFilterable": true,
    "isDate": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "due",
    "disablePadding": false,
    "label": "Due",
    "isFilterable": true,
    "isDate": false,
    "showColumnUnExpanded": true
  },
  {
    "id": "actions",
    "disablePadding": false,
    "label": "Actions",
    "isFilterable": false,
    "isDate": false,
    "showColumnUnExpanded": true
  }

]

export const userHeaders = [
  {
    "id": "id",
    "disablePadding": true,
    "label": "ID",
    "isFilterable": false,
    "showColumnUnExpanded": false
  },
  {
    "id": "findingName",
    "disablePadding": false,
    "label": "Name",
    "isFilterable": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "resourceids",
    "disablePadding": false,
    "label": "Resource IDs",
    "isFilterable": false,
    "showColumnUnExpanded": false
  },
  {
    "id": "severity",
    "disablePadding": false,
    "label": "Severity",
    "isFilterable": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "classification",
    "disablePadding": false,
    "label": "Classification",
    "isFilterable": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "org",
    "disablePadding": false,
    "label": "Org",
    "isFilterable": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "status",
    "disablePadding": false,
    "label": "Status",
    "isFilterable": false,
    "showColumnUnExpanded": true
  },
  {
    "id": "createdDate",
    "disablePadding": false,
    "label": "Created Date",
    "isFilterable": true,
    "isDate": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "falsePositiveProbability",
    "disablePadding": false,
    "label": "False Positive Probability",
    "isFilterable": true,
    "isDate": true,
    "showColumnUnExpanded": true
  },
  {
    "id": "riskScore",
    "disablePadding": false,
    "label": "Risk Score",
    "isFilterable": true,
    "isDate": true,
    "showColumnUnExpanded": true
  },
  
  {
    "id": "due",
    "disablePadding": false,
    "label": "Due",
    "isFilterable": true,
    "isDate": false,
    "showColumnUnExpanded": true
  },
  
{
    "id": "actions",
    "disablePadding": false,
    "label": "Actions",
    "isFilterable": false,
    "isDate": false,
    "showColumnUnExpanded": true
  }
]

export const similarIncidentHeaders=[
  "Name","Severity","Classification","Org","Assigned To","Status","Due"
]